import React from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import {
    SidebarHeader,
    ScrollableBox,
    Checkbox,
    EnhancedFormik,
    EnhancedNavigationGuard,
    SaveButton,
    Form,
    Row,
    CancelButton,
    Feature,
} from '@mssgme/ui';
import { useActions, useWorkspace } from '@mssgme/hooks';
import { usePreview } from '../../../UI';

import styles from './styles.scss';

export default function ReviewsEdit() {
    const actions = useActions();
    const { t } = useTranslation('cards');
    const { card } = useWorkspace();
    const { updatePreview } = usePreview();

    const leftButton = <CancelButton tag={Link} to="/p" styled="backIcon" />;

    return (
        <EnhancedFormik
            initialValues={{
                reviews: {
                    enabled: get(card, 'reviews.enabled', false),
                },
            }}
            onSubmit={(values) => actions.api.card.update({ payload: { ...card, ...values } })}
            onChange={updatePreview}
        >
            {({ values, setFieldValue, submitForm }) => (
                <EnhancedNavigationGuard>
                    <div className={styles.root}>
                        <SidebarHeader
                            heading={t('reviewsEdit.header')}
                            leftButton={leftButton}
                            rightButton={<SaveButton />}
                        />
                        <ScrollableBox>
                            <Feature rule="reviews" className={styles.noaccess}>
                                <Form onSubmit={submitForm}>
                                    <Row>
                                        <Checkbox
                                            name="reviews.enabled"
                                            checked={values.reviews.enabled}
                                            placeholder={t('reviewsEdit.label')}
                                            onChange={(e) => {
                                                setFieldValue('design.branding', e.target.checked);
                                            }}
                                        />
                                    </Row>
                                </Form>
                            </Feature>
                        </ScrollableBox>
                    </div>
                </EnhancedNavigationGuard>
            )}
        </EnhancedFormik>
    );
}
